import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import {
  PromotionType,
  PromotionTypeModel,
} from "../../../domain/models/promotion-type";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteClientPromotionType implements PromotionType {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient
  ) {}

  async list(): Promise<PromotionTypeModel[]> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/list`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.badRequest:
        throw httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }
}
